import { defineMessages } from 'react-intl';

export default defineMessages({
  dateInput: {
    id: 'app.components.date.dateInput',
    defaultMessage: 'La fecha ingresada no es válida',
  },
});
